import { render, staticRenderFns } from "./List.vue?vue&type=template&id=f478b3a4&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "../main.css?vue&type=style&index=0&id=f478b3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478b3a4",
  null
  
)

export default component.exports